module.exports = __webpack_public_path__ + "static/media/cp.7bb4dafc.jpg";